import { Heading } from "src/components/ui/heading"
import { css } from "styled-system/css"

import { AppCollapsible } from "@components"
// Assuming these or similar components exist in your design system
import * as Card from "src/components/ui/card"
import { Flex } from "styled-system/jsx"

export default function BrokersPage() {
  return (
    <article class={css({ display: 'grid', gap: 6 })}>

      <div class={css({ display: 'grid', gap: 4 })}>

        {/* TradingView */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">TradingView</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                Francis uses Tradingview for all charting and technical analysis and The HVF Method. It offers powerful, user-friendly charting with extensive indicators, drawing tools, and customizable layouts.
              </p>
              <p>Set up your account using our affiliate link below:</p>
              <p>
                <a href="https://thesnipercircle.com/tradingview/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>
                  Sign up to TradingView here
                </a>
              </p>
              <p>
                A mini-course to get started with TradingView, specifically for use with The HVF Method, can be found under the Courses tab or link below:
              </p>
              <p>
                <a href="https://thesnipercircle.com/courses/tradingview-mini-course/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>
                  TradingView Mini-Course
                </a>
              </p>
            </div>
          </AppCollapsible>
        </Card.Root>

        {/* MEXC */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">MEXC – Trade Crypto, Metals, Oil and More with Good Liquidity</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                MEXC is a global exchange founded in 2018 and headquartered in Seychelles. It is one of the larger exchanges by futures trading volume globally. While best known as a crypto exchange, MEXC also offers leveraged trading on gold and silver, oil and a selection of stocks.
              </p>
              <p>
                For Snipers, the ability to trade XAU and XAG alongside crypto on a single low-fee platform is the standout advantage.
              </p>
              <p>
                <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>Sign Up for MEXC here</a>
              </p>
              <p>
                <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>Watch our MEXC broker presentation webinar here</a>
              </p>

              <p><strong>NOTE – Unsupported Jurisdictions:</strong> MEXC does not support customers located in UK, USA, China and Quebec.</p>
              <p><strong>MEXC Card:</strong> Spend your crypto worldwide. Available in most jurisdictions.</p>
              <p>MEXC can be connected to your TradingView account.</p>

              <div class={css({ mt: 4, display: 'grid', gap: 3, borderTop: '1px solid', borderColor: 'gray.200', pt: 4 })}>
                <Heading textStyle="md">Frequently Asked Questions</Heading>

                <p><strong>Q: What is MEXC?</strong><br />A: MEXC is a global centralized cryptocurrency exchange founded in 2018, serving over 40 million users across more than 170 countries.</p>
                <p><strong>Q: Is KYC required?</strong><br />A: Yes. KYC is now mandatory. Previously it may not have been required, but users now need to complete KYC to access full account functionality, especially withdrawals.</p>
                <p><strong>Q: Which regions are restricted?</strong><br />A: The restricted regions are the UK, USA, China, and Quebec. Users in these areas may be blocked from accessing the website or may face withdrawal restrictions.</p>
                <p><strong>Q: What should legacy non-KYC account holders do if they need to withdraw?</strong><br />A: They may need to complete a withdrawal appeal form. This is especially relevant for users in restricted regions who cannot complete KYC.</p>
                <p><strong>Q: Can an existing MEXC account be linked to the Market Sniper bonus structure?</strong><br />A: If the account was registered within the last 60 days before 3 June 2026, it may be possible to link it under the Market Sniper referral/affiliate structure. Older accounts generally cannot be moved.</p>
                <p><strong>Q: Can users open more than one account?</strong><br />A: Users may have up to three accounts, provided different IDs are used, such as a passport, driver’s license, or residency document.</p>
                <p><strong>Q: Is there a permanent referral link and a separate promo link?</strong><br />A: Yes, the link is on our brokers page. The permanent community referral link keeps users under the Market Sniper umbrella, while the promo campaign link gives access to time-limited bonuses.</p>
                <p><strong>Q: How long does the promotional campaign last?</strong><br />A: The campaign typically run for around 30 days, with a possibility that MEXC may extend it if there is enough demand.</p>
                <p><strong>Q: What markets are available on MEXC?</strong><br />A: MEXC offers crypto pairs, spot trading, futures/perpetual contracts, precious metals, crude oil, global stocks, FX markets, and some real-stock access depending on region.</p>
                <p><strong>Q: Does MEXC offer spot trading?</strong><br />A: Yes, with over 2,000 pairs available and no liquidation risk.</p>
                <p><strong>Q: Does MEXC offer futures trading?</strong><br />A: Yes. MEXC offers perpetual futures, isolated and cross-margin positions, and leverage up to 200x on certain pairs. Users were warned to be careful with high leverage.</p>
                <p><strong>Q: Are privacy tokens like Monero available?</strong><br />A: Monero was shown as available in perpetual futures (June 2026).</p>
                <p><strong>Q: Does MEXC support fiat deposits and withdrawals?</strong><br />A: Yes. Fiat deposits, debit or credit card funding, third-party providers such as Simplex, Banxa, and MoonPay, SEPA for Europe, and peer-to-peer options.</p>
                <p><strong>Q: Should users use credit cards to fund accounts?</strong><br />A: It is recommended not to use credit cards because they may trigger cash-advance fees. Debit cards are suggested instead.</p>
                <p><strong>Q: Are internal transfers available?</strong><br />A: Yes. Users can send funds internally between MEXC accounts using a UID, and these internal transfers are free.</p>
                <p><strong>Q: What is MEXC Earn?</strong><br />A: MEXC Earn allows users to earn yield on assets through flexible or locked products. Flexible products offer lower yield with easier access, while locked products offer higher yield over fixed terms such as 30, 60, or 90 days.</p>
                <p><strong>Q: Does MEXC have a launchpool?</strong><br />A: Yes. MEXC Launchpool is a way to stake certain tokens and potentially receive airdrops from new listings.</p>
                <p><strong>Q: Is there a MEXC card?</strong><br />A: A card is available through a partnership with ether.fi. It is a virtual card with the option to order a physical card, subject to region and provider restrictions.</p>
                <p><strong>Q: Can the card be used everywhere?</strong><br />A: It typically uses Visa or Mastercard rails, but availability depends on the card provider’s supported regions and KYC requirements.</p>
                <p><strong>Q: Does MEXC provide proof of reserves?</strong><br />A: Yes. MEXC has a proof-of-reserves page where users can check backing and solvency information.</p>
                <p><strong>Q: Who should users contact if they have support issues?</strong><br />A: Users should first go through MEXC support.</p>
              </div>
            </div>
          </AppCollapsible>
        </Card.Root>

        {/* Wise */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">Wise</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                Francis uses Wise to hold CHF, and pay living costs in other countries around the world, as well as to fund his Bullionvault account:
              </p>
              <p>
                <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>
                  Sign up for your Wise account here
                </a>
              </p>
            </div>
          </AppCollapsible>
        </Card.Root>

        {/* BTCC */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">Private: BTCC – Trade Crypto, Stocks &amp; Forex Without KYC</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                BTCC stands out as a veteran crypto exchange with a solid track record in security, regulatory compliance, and trading features—especially for derivatives and high-leverage strategies. Its platform is well-suited for both beginners (via demo trading) and advanced traders (via low fees, robust tools, and copy trading).
              </p>
              <p>
                Established in June 2011, BTCC is one of the longest-running cryptocurrency exchanges globally, with roots tracing back to its original name “BTC China.”
              </p>
              <p>
                Specializes in crypto derivatives, offering up to 500× leverage on futures like BTC/USDT and ETH/USDT.
              </p>
              <p>
                <strong>FXEmpire 2025 Awards:</strong> Lowest Fee Exchange, Best Fiat-to-Crypto Trading Platform, Best Exchange in the USA.
              </p>
              <p>
                Watch our presentation here: <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>BTCC – Trade Crypto, Stocks &amp; Forex Without KYC</a>
              </p>
              <p>
                Link to sign up and get your 10% bonus, exclusive to premium community members: <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>Sign up here</a>
              </p>
              <p>
                <strong>NOTE:</strong> Any deposit bonus is forfeited upon withdrawal. It is important to understand the mechanics of BTCC margin trading, particularly cross-margin trading, as insufficient understanding may result in unexpected position closures and P&amp;L outcomes.
              </p>
              <p>
                See link and related posts here: <a href="https://www.btcc.com/en-US/support-center/detail/45778231565977" class={css({ color: 'blue.600', textDecoration: 'underline' })}>BTCC Support Center</a>
              </p>
              <p>
                Those located in UK need to use a VPN (See presentation video).
              </p>
              <div>
                <p><strong>Direct platform-specific queries to:</strong></p>
                <p>Email BTCC Support: <a href="mailto:jonathan.hk@btcc.com" class={css({ color: 'blue.600', textDecoration: 'underline' })}>jonathan.hk@btcc.com</a></p>
                <p>BTCC Telegram Support Channel: <strong>@Topcatted</strong></p>
              </div>
            </div>
          </AppCollapsible>
        </Card.Root>

        {/* ITM Trading */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">ITM Trading: Purchasing Gold and Silver for U.S. Citizens</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                The fiat endgame is unfolding like a game, and while it’s crucial to maintain humor and a sound mind,...
              </p>
              <p>
                If you’re just starting out or thinking about buying gold and silver, I highly recommend ITM Trading. With over 28 years of experience, ITM Trading specializes in helping clients protect and grow wealth through data-backed research and education. They focus on creating personalized, pressure-free plans. Trust ITM Trading to help you build a solid gold and silver strategy to secure your assets and your family’s future. Give them a call today or schedule your free consultation.
              </p>
              <p>
                <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>
                  Buy Silver and Gold as a US American here with ITM trading
                </a>
              </p>
            </div>
          </AppCollapsible>
        </Card.Root>

        {/* Tickmill */}
        <Card.Root gridTemplateRows="auto 1fr" display="grid">
          <AppCollapsible
            headerContent={
              <Flex justifyContent="space-between" alignItems="center" height={12} p={3}>
                <Heading textStyle="sm">Tickmill – Great Broker for non Europeans, US or Australian Citizens</Heading>
              </Flex>
            }
          >
            <div class={css({ p: 4, display: 'grid', gap: 3 })}>
              <p>
                For those residing outside of Europe, the United States, or Australia, we highly suggest exploring Tickmill – a top-tier...
              </p>
              <p>Within a single platform, Tickmill accommodates a diverse array of trading options including:</p>
              <ul>
                <li>Hong Kong Dollar</li>
                <li>Cryptocurrency</li>
                <li>Gold</li>
                <li>Oil</li>
              </ul>
              <p>Experience the breadth and depth of Tickmill’s offerings for yourself through the following link:</p>
              <p>
                <a href="/" class={css({ color: 'blue.600', textDecoration: 'underline' })}>
                  Check out Tickmill
                </a>
              </p>
            </div>
          </AppCollapsible>
        </Card.Root>

      </div>
    </article>
  )
}
